<template>
  <footer class="app-footer">
    <a href="mailto:digitalnimenu@gmail.com" class="app-footer-link">
      <p>&copy; 2020 - {{ currentYear }} digitalnimenu.com</p>
      <p style="text-decoration: underline">digitalni.menu@gmail.com</p>
    </a>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data: () => ({
    currentYear: new Date().getFullYear(),
  }),
  props: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.app-footer {
  background-color: black;
  color: white;
  line-height: 1.4;
}
.app-footer-link {
  font-size: 12px;
  padding: 1rem;
  height: 100%;
  display: grid;
  justify-items: center;
}
</style>
